export namespace CorrelationVector {
  let baseHash: string | undefined;
  let baseId: number = 0;

  /**
   * Get a new correlation vector representing the next event in sequence
   */
  export function getNext(): CV {
    if (baseHash === undefined) {
      baseHash = generatePseudoHash();
    }

    return new CV(baseHash, ++baseId);
  }

  /**
   * Get a new correlation vector parented to this one
   * @param parent
   */
  export function getNextChild(parent: CV) {
    return new CV(parent.getString(), ++parent.nextChild);
  }

  export class CV {
    base: string;
    id: number;
    nextChild: number;

    constructor(base: string, id: number) {
      this.base = base;
      this.id = id;
      this.nextChild = 0;
    }

    getString(): string {
      return `${this.base}.${this.id}`;
    }
  }

  function generatePseudoHash() {
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    let hashLength = 22;

    let result = [];

    for (let i = 0; i < hashLength; i++) {
      // tslint:disable: insecure-random (security is not a concern here and secure crypto function is not available on all platform)
      result.push(characters.charAt(Math.floor(Math.random() * characters.length)));
    }
    return result.join('');
  }
}
